/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * VerifyEmail Input Action
 */
export class VerifyEmailInput implements Msdyn365.IActionInput {
    public emailAddress: string;
    public channelNaturalId?: string;
    constructor(emailAddress: string, channelNaturalId?: string) {
        this.emailAddress = emailAddress;
        this.channelNaturalId = channelNaturalId;
    }
    public getCacheKey = () => `DEFAULT + ${this.emailAddress} ${new Date()}`;
    public getCacheObjectType = () => `IVerifyEmailData  ${new Date()}`;
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IVerifyEmailData {
    response: boolean;
}

const createInput = (): Msdyn365.IActionInput => new VerifyEmailInput('');

async function action(input: VerifyEmailInput, ctx: Msdyn365.IActionContext): Promise<IVerifyEmailData> {
    let result: boolean = false;
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SetVerificationEmail`,
        'post',
        {
            email: input.emailAddress,
            language: ctx.requestContext.locale || 'en-us',
            channelNaturalId: input.channelNaturalId || ctx.requestContext?.channel?.ChannelNaturalId || ''
        },
        { headers: { oun: ctx.requestContext.apiSettings.oun } }
    ).then(res => {
        result = (res?.data as any)?.value;
    });

    // TODO: When Backend fixed error, remove
    if (!result) {
        return { response: true };
    }
    return { response: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IVerifyEmailData>>action,
    id: 'SetVerificationEmail',
    input: createInput
});
